import { useOffers } from "@nju/data-access-portal-offers";
import { SubscribeOfferDetails } from "@nju/feature-portal-offers";
import { Icon } from "@nju/icons";
import {
  BlockText,
  Drawer,
  Heading,
  Panel,
  Separator,
  Text,
  useOverlay,
} from "@nju/ui";

export function ConvergenceBanner() {
  const drawer = useOverlay();
  const { mobile } = useOffers();
  const offer = mobile.indefiniteOffers.find((offer) => {
    return offer.display;
  });

  return (
    <>
      {drawer.isOpened && (
        <Drawer onClose={drawer.close}>
          <SubscribeOfferDetails
            mobileOffers={mobile.indefiniteOffers}
            type="dashboard"
          />
        </Drawer>
      )}
      <Panel
        forceShowTitleBlock={true}
        invisibleSeparator={true}
        separatorSize="none"
        testId="convergence-offer-banner"
      >
        <div className="h-full flex flex-col justify-between">
          <div>
            <Icon
              className="mr-3 w-6 h-6 from-tablet:w-8 from-tablet:h-8"
              name="badge-percent"
              tone="accent"
            />
            <Heading
              className="mt-4"
              font="ttfirs"
              tone="neutral"
              variant="h4"
              weight="bold"
            >
              w pakiecie taniej
            </Heading>
            <Separator size="xxs" tone="invisible" />
            <BlockText className="from-tablet:max-w-[330px]">
              <Text size="l">
                Kup nju światłowód i nju subskrypcja, by płacić mniej o{" "}
                {offer?.bundleDiscount} zł miesięcznie.
              </Text>
            </BlockText>
          </div>
          <div>
            <span
              className="gap-3 mt-5 cursor-pointer flex items-center"
              onClick={drawer.open}
              role="button"
            >
              <Text tone="accent"> sprawdź</Text>
              <Icon height={18} name="arrow-right" tone="accent" width={18} />
            </span>
          </div>
        </div>
      </Panel>
    </>
  );
}
